<template>

    <div class="w-50 m-4 mt-3" v-if="notificationDetails">
        <h3>Notification Details</h3>

        <p class="mt-3" v-if="currentAction!=null">Thank you for responding to the notification regarding this {{ notificationDetails.eventSource }}</p>

        <p>
            <ul>
                <li><strong>{{ notificationDetails.eventSource }}:&nbsp;</strong>{{ notificationDetails.subject }}</li>
                <li><strong>Event:&nbsp;</strong>{{ notificationDetails.event }}</li>
                <li><strong>{{ notificationDetails.targetDateTimeLabel }}:&nbsp;</strong>{{ formatDateTime(notificationDetails.targetDateTimeUTC, 'DD/MM/YYYY h:mmA', true, false) }}</li>
                <li v-if="notificationDetails.status"><strong>Status: &nbsp;</strong><span :class="'text-' + notificationDetails.statusVariant +' font-weight-bold'">{{ notificationDetails.status }}</span></li>
                <template v-if="notificationDetails.details">
                    <li v-for="(detailsEntry, index) in notificationDetails.details" :key="index"><strong v-if="detailsEntry.key">{{ detailsEntry.key }}: &nbsp;</strong>{{ detailsEntry.value }}</li>
                </template>
            </ul>
        </p>

        <div v-if="(currentAction != null) && !currentActionValid">
            <b-alert variant="danger" show dismissible>Your chosen action - <strong>{{ currentAction.displayName }}</strong> - is no longer valid.</b-alert>
        </div>
        <div v-if="(currentAction != null) && currentActionValid">
            <b-alert :variant="currentAction.variant" show>Please confirm your chosen action - <strong>{{ currentAction.displayName }}</strong></b-alert>

            <h5 class="mt-2">Optional message:</h5>
            <b-form-textarea id="message-box"
                             v-model="comment"
                             class="w-100"
                             rows="3"
                             max-rows="6"></b-form-textarea>

            <div class="d-flex justify-content-end mt-3">
                
                <!-- this should be all rendered out of the actions: [] which we get from the loadNotificationDetails -->
                <b-button variant="danger" class="mr-1" @click="currentAction = null">Cancel</b-button>
                <b-button size="md" variant="success" @click="confirmAction">Yes, {{ currentAction.displayName }}</b-button>

            </div>
        </div>

        <div v-if="((currentAction == null) || !currentActionValid) && (((notificationDetails.actions != null) && (notificationDetails.actions.length > 0)) || notificationDetails.userHasAccessToEventSource)">
            <div class="d-flex justify-content-end mt-3">
                <!-- this should be all rendered out of the actions: [] which we get from the loadNotificationDetails -->
                <!-- <b-button class="mr-1" :href="baseUrl + '/Notifications'" variant="secondary">Back to Notification Dashboard</b-button> -->
                <b-button :href="notificationTargetUrl + '/' + notificationDetails.id" v-if="notificationDetails.userHasAccessToEventSource">Go to {{ notificationDetails.eventSource }}</b-button>
                <b-button :variant="action.variant" class="ml-1" @click="currentAction = action" v-for="action in notificationDetails.actions" :key="action.inValue">{{ action.displayName }}</b-button>
            </div>
            <div class="d-flex justify-content-end mt-3" v-if="notificationDetails.actionDueDateTimeUTC">
                <div><strong>Action due by:&nbsp;</strong>{{ formatDateTime(notificationDetails.actionDueDateTimeUTC, 'DD/MM/YYYY h:mmA', true, false) }}</div>
            </div>        
        </div>
    </div>
</template>
    
<script>

    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import { DateTimePickerPlugin } from '@syncfusion/ej2-vue-calendars';

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import DateTimeMixin from '../mixins/DateTimeMixin';

    Vue.use(BootstrapVue);
    Vue.use(DateTimePickerPlugin);

    export default {
        name: 'NotificationLanding',
        mixins: [DateTimeMixin, ErrorsMixin],
        props: {

            apiBaseUrl: {
                type: String,
                required: true
            },
            baseUrl: {
                type: String,
                required: true
            },
            notificationTargetUrl: {
                type: String,
                required: true
            },
            notificationId: {
                type: String,
                required: true
            },
            action: { // if this empty - offer buttons, as there is no reaction as yet, as in user pressed the VIEW LINK
                type: Object,
                default: null

                // this comes in
                /*"Actions":[{"ButtonVariant":"success","ButtonColor":"#28a745","IntValue":0,"EnumValue":0,"StringValue":"AcceptAssignment","UnderlyingValue":0,"DisplayName":"accept"},{"ButtonVariant":"danger","ButtonColor":"#dc3545","IntValue":1,"EnumValue":1,"StringValue":"RejectAssignment","UnderlyingValue":1,"DisplayName":"reject"},{"ButtonVariant":"warning","ButtonColor":"#ffc107","IntValue":2,"EnumValue":2,"StringValue":"ListenToAssignedAudio","UnderlyingValue":2,"DisplayName":"listen to audio"}]}

                incoming prop: reaction contains pressed button action, if nothing pressed, the actions array should  be rendered for users choise (this would be same as
                pressing button in email)

                if action present: show same Action to confirm and a cancel button - cancel should enable all possible actions again.

                */

            }
        },

        data: function () {

            return {
                currentAction: this.action,
                comment: '',
                notificationDetails: null
              
            }
        },

        computed: {
            currentActionValid: function () {
                if (this.currentAction == null) return true;
                if ((this.notificationDetails == null) || (this.notificationDetails.actions == null)) return false;
                var action = this.notificationDetails.actions.find(e => e.intValue == this.currentAction.intValue);
                return (action != null);
            }
        },

        methods: {

            confirmAction: function () {

                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'Notification/';
                url += this.notificationId;
                url += '/action/'; 

                var reactionObject = { "action": this.currentAction.intValue, "comment": this.comment };

                this.currentErrors = [];

                axios
                    .post(url, JSON.stringify(reactionObject),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(() => {
                        this.currentAction = null;
                        this.loadNotificationDetails();
                     
                        this.$bvToast.toast('Action confirmed', {
                            title: 'Action confirmed',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                     
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    })
                    .finally(() => {

                    })
            },

            loadNotificationDetails: function () {

                this.currentErrors = [];
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';

                url += 'Notification/';
                url += this.notificationId;
                axios
                    .get(url)
                    .then(response => {
                        this.notificationDetails = response.data;
                        console.log(JSON.stringify(this.notificationDetails));
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },
            
        }, // methods

        mounted: function () {
            this.loadNotificationDetails();
            
        }
    } // export default

</script>

<style scoped>

    p {
        font-size: 18px;
    }

</style>


 